import firebase from "firebase/app";
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/messaging";
import "firebase/storage";
import dotenv from "dotenv";

dotenv.config();

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyBt0fRqy1bq-Bpl7sx9GsQTkDw7yY-Ll5w",
    authDomain: "coinstorey-195f4.firebaseapp.com",
    projectId: "coinstorey-195f4",
    storageBucket: "coinstorey-195f4.appspot.com",
    messagingSenderId: "1068418582349",
    appId: "1:1068418582349:web:76ab5cda4b65b7e3fe9904",
  });
} else {
  firebase.app(); // if already initialized, use that one
}
export default firebase;
